// Crossfade carousel for `.itlu-3d-gallery` (3D urn Gallery + Behind the
// Scenes blocks). Figures are absolutely stacked via CSS; this module
// cycles `.is-active` between them and renders dot indicators.

(() => {
  const INTERVAL_MS = 5000;
  const galleries = document.querySelectorAll('.itlu-3d-gallery');
  if (!galleries.length) return;

  const init = (root) => {
    const items = Array.from(root.querySelectorAll('.itlu-3d-gallery__item'));

    // Eagerly fetch every image in the carousel. The slides are stacked with
    // opacity:0, which prevents lazy-loaded <img>s from triggering until the
    // user scrolls them into view — but cycling between them is the whole
    // point, so a hidden slide that hasn't fetched yet appears as a blank
    // crossfade target. Forcing `loading="eager"` here loads them on init.
    items.forEach((it) => {
      it.querySelectorAll('img').forEach((img) => {
        img.loading = 'eager';
        if (img.dataset.src && !img.src) img.src = img.dataset.src;
      });
    });

    if (items.length < 2) {
      items[0]?.classList.add('is-active');
      return;
    }

    let i = 0;
    items[0].classList.add('is-active');

    const dots = document.createElement('div');
    dots.className = 'itlu-3d-gallery__dots';
    items.forEach((_, idx) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'itlu-3d-gallery__dot';
      btn.setAttribute('aria-label', `Show image ${idx + 1} of ${items.length}`);
      btn.dataset.index = String(idx);
      if (idx === 0) btn.classList.add('is-active');
      dots.appendChild(btn);
    });
    root.appendChild(dots);

    const goto = (next, { manual = false } = {}) => {
      if (next === i) return;
      items[i].classList.remove('is-active');
      dots.children[i].classList.remove('is-active');
      i = next;
      items[i].classList.add('is-active');
      dots.children[i].classList.add('is-active');
      if (manual) restartTimer();
    };

    let timer = null;
    const startTimer = () => {
      timer = window.setInterval(() => goto((i + 1) % items.length), INTERVAL_MS);
    };
    const restartTimer = () => {
      if (timer) window.clearInterval(timer);
      startTimer();
    };

    dots.addEventListener('click', (e) => {
      const btn = e.target.closest('.itlu-3d-gallery__dot');
      if (!btn) return;
      goto(Number(btn.dataset.index), { manual: true });
    });

    root.addEventListener('mouseenter', () => { if (timer) window.clearInterval(timer); });
    root.addEventListener('mouseleave', () => restartTimer());

    startTimer();
  };

  galleries.forEach(init);
})();
